import { customElement } from "lit/decorators.js";
import { SvgIconElement } from "../common/svg-icon-element.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
let ProductsAndPagesCourseBuilderImageIcon = class extends SvgIconElement {
  render() {
    return this.renderIcon({
      template: '<path d="M1 3.5c.552 0 1 .448 1 1v17c0 .276.224.5.5.5h17c.552 0 1 .448 1 1s-.448 1-1 1H2c-1.105 0-2-.895-2-2V4.5c0-.552.448-1 1-1zM22 0c1.105 0 2 .895 2 2v16.5c0 1.105-.895 2-2 2H5.5c-1.105 0-2-.895-2-2V2c0-1.105.895-2 2-2zm-6 8.5c-.38-.018-.735.186-.911.523l-2.437 4.527c-.041.077-.12.127-.208.132-.088.004-.171-.038-.22-.111l-.83-1.246c-.198-.297-.539-.466-.895-.444-.356.023-.673.233-.832.552l-2.114 4.23c-.078.155-.07.34.022.487.09.147.252.237.425.237h12.003c.171 0 .33-.087.423-.232.092-.144.103-.326.03-.481l-3.578-7.6c-.16-.342-.5-.564-.878-.574zM9.75 4.247c-1.105 0-2 .895-2 2s.895 2 2 2 2-.895 2-2-.895-2-2-2z"/>',
      viewBox: [0, 0, 24, 24]
    });
  }
};
ProductsAndPagesCourseBuilderImageIcon = __decorateClass([
  customElement("elm-products-and-pages-course-builder-image-icon")
], ProductsAndPagesCourseBuilderImageIcon);
export { ProductsAndPagesCourseBuilderImageIcon };
